import { immerable } from 'immer';
import { CameraImageModel, ICameraImageModel } from './camera-image.model';
import { IProjectModel } from './project.model';

export interface IExternalCameraModel {
    _id: string;
    name: string;
    project: Pick<IProjectModel, '_id' | 'name'>;
    latestImage: Pick<ICameraImageModel, '_id' | 'name' | 'datetime' | 'urlThumb'>;
}

/* -------------------------------------------------------------------------------------------------
 * ExternalCameraModel
 * -----------------------------------------------------------------------------------------------*/
export class ExternalCameraModel {
    [immerable] = true;

    _id: string;
    name: string;
    project: Pick<IProjectModel, '_id' | 'name'>;
    latestImage: Pick<ICameraImageModel, '_id' | 'name' | 'datetime' | 'urlThumb'>;

    constructor(data: Partial<IExternalCameraModel>) {
        this._id = data._id;
        this.name = data.name;
        this.project = data.project;

        if (data.latestImage) {
            this.latestImage = CameraImageModel.fromObject(data.latestImage);
        } else {
            this.latestImage = null;
        }
    }

    static fromObject(data: Partial<IExternalCameraModel>): ExternalCameraModel {
        const model = new ExternalCameraModel(data);

        return model;
    }

    static fromObjectList(data: Partial<IExternalCameraModel>[]): ExternalCameraModel[] {
        return data.map((row) => ExternalCameraModel.fromObject(row));
    }

    static cloneFrom(data: Partial<IExternalCameraModel>): ExternalCameraModel {
        const model = new ExternalCameraModel(data);

        return model;
    }

    toObject(): IExternalCameraModel {
        const data: Partial<IExternalCameraModel> = {
            _id: this._id,
            name: this.name,
            project: this.project,
            latestImage: this.latestImage,
        };

        return data as IExternalCameraModel;
    }
}
